<template>
  <div class="sdk-wrap">
    <!-- <p>第三方SDK目录</p> -->
    <div class="top-space">
      <p class="gray ">修改时间2024年01月08号</p>
      <p class="gray">生效时间2024年01月08号</p>
    </div>
    <p class="text-offset-2 top-space">为保障中保车服产品相关功能的实现与应用的稳定运行，我们会接入由第三方提供的软件开发包（SDK）以实现相关目的。不同版本的第三方SDK会有所不同，一般包括推送通知消息类、地图导航类、统计分析类等。我们会对合作方获取信息的软件开发包（SDK）进行严格的安全监测，以保障数据安全。您可以通过以下链接查看第三方的数据使用和保护规则。
    </p>
    <div class="top-space">
      <p class="text-offset-2 title">1、SDK名称：极光推送</p>
      <p class="text-offset-2">所属机构名称：深圳市和讯华谷信息技术有限公司</p>
      <p class="text-offset-2">使用目的：为 APP 用户提供信息推送服务</p>
      <p class="text-offset-2">使用场景：向使用app用户推送订单状态消息</p>
      <p class="text-offset-2">收集方式：SDK本机收集</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本，确保消息准确下发；</p>
      <p class="text-offset-2">设备标识符（IMEI、IDFA、IDFV、Android ID、GID、 MAC、OAID、VAID、AAID、IMSI、MEID、UAID、SN、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；</p>
      <p class="text-offset-2">网络信息(运营商名称、IP 地址、WiFi 信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息<span class="importance">（经纬度）</span>：用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；</p>
      <p class="text-offset-2">软件安装列表：使用行为和目的(应用崩溃信息、通知开关状态、APP 应用安装列表及活跃状态、APP 应用页面信息、APP 功能事件相关信息)：当一个设备有多个 APP 的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的。</p>
      <p class="text-offset-2">wifi 网络信息和 WIFI列表：获取网络状态</p>
      <p class="text-offset-2">申请系统权限：网络权限、读取电话状态权限、读取外部存储、写入外部存储、读取手机状态权限、获取<span class="importance">精确位置</span>权限、<span class="importance">近似位置</span>权限</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://www.jiguang.cn/license/privacy"
      >https://www.jiguang.cn/license/privacy</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">2、SDK名称：小米推送</p>
      <p class="text-offset-2">所属机构名称：北京小米移动软件有限公司</p>
      <p class="text-offset-2">使用目的：为 小米 用户提供信息推送服务</p>
      <p class="text-offset-2">使用场景：向小米用户推送订单状态消息</p>
      <p class="text-offset-2">收集方式：SDK本机收集</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">设备标识符（Android ID、OAID、GAID）、设备信息。</p>
      <p class="text-offset-2">网络信息，包括网络类型、运营商名称。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"

        href="https://dev.mi.com/console/doc/detail?pId=1822"
      >https://dev.mi.com/console/doc/detail?pId=1822</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">3、SDK名称：华为推送</p>
      <p class="text-offset-2">所属机构名称：华为软件技术有限公司</p>
      <p class="text-offset-2">使用目的：为 华为 用户提供信息推送服务</p>
      <p class="text-offset-2">使用场景：向华为用户推送订单状态消息</p>
      <p class="text-offset-2">收集方式：SDK本机收集</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息。</p>
      <p class="text-offset-2">网络信息，包括网络类型、运营商名称。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
      >https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">4、SDK名称：VIVO推送</p>
      <p class="text-offset-2">所属机构名称：广东天宸网络科技有限公司及将来受让运营 vivo 开放平台的公司</p>
      <p class="text-offset-2">使用目的：为 vivo 用户提供信息推送服务</p>
      <p class="text-offset-2">使用场景：向vivo用户推送订单状态消息</p>
      <p class="text-offset-2">收集方式：SDK本机收集</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">设备信息，包括设备id。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://www.vivo.com.cn/about-vivo/privacy-policy"
      >https://www.vivo.com.cn/about-vivo/privacy-policy</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">5、SDK名称：OPPO推送</p>
      <p class="text-offset-2">所属机构名称：广东欢太科技有限公司</p>
      <p class="text-offset-2">使用目的：为 oppo 用户提供信息推送服务</p>
      <p class="text-offset-2">使用场景：向oppo用户推送订单状态消息</p>
      <p class="text-offset-2">收集方式：SDK本机收集</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">设备标识符（IMEI、ICCID、IMSI、Android ID、GAID）、应用信息（应用包名、版本号和运行状态）、网络信息（IP 或域名连接结果，当前网络类型）。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://open.oppomobile.com/wiki/doc#id=10288"
      >https://open.oppomobile.com/wiki/doc#id=10288</a>
    </div>

    <div class="top-space">
      <p class="text-offset-2 title">{{ isIOS ? '2': '6' }}、高德开放平台定位SDK</p>
      <p class="text-offset-2">所属机构：高德软件有限公司</p>
      <p class="text-offset-2">使用目的：为用户提供定位功能。</p>
      <p class="text-offset-2">使用场景：App开启位置信息权限后上报位置以获得派单</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">涉及个人信息：位置信息（<span class="importance">经纬度、精确位置</span>、粗略位置）、设备信息【MAC地址、硬件序列号、IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息、外部存储目录】、设备标识信息（IDFA、IDFV、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）、Android ID、<span class="importance">WiFi 网络信息</span>。</p>
      <p class="text-offset-2">申请系统权限：位置、后台定位、存储、网络权限、读取电话状态权限</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://lbs.amap.com/pages/privacy"
      >https://lbs.amap.com/pages/privacy</a>
    </div>

    <div class="top-space">
      <p class="text-offset-2 title">{{ isIOS ? '3': '7' }}、高德开放平台地图SDK</p>
      <p class="text-offset-2">所属机构：高德软件有限公司</p>
      <p class="text-offset-2">使用目的：为了实现地图展示、定位、搜索等服务。</p>
      <p class="text-offset-2">使用场景：App地图展示用户当前所在的位置</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">涉及个人信息：位置信息（<span class="importance">经纬度、精确位置</span>、粗略位置）、设备信息【IMEI、IMSI、IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息、外部存储目录】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）、Android ID、<span class="importance">WiFi 网络信息、MAC 地址</span>。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://lbs.amap.com/pages/privacy"
      >https://lbs.amap.com/pages/privacy</a>
    </div>

    <div class="top-space">
      <p class="text-offset-2 title">{{ isIOS ? '4': '8' }}、友盟统计</p>
      <p class="text-offset-2">所属机构名称：友盟同欣（北京）科技有限公司</p>
      <p class="text-offset-2">使用目的：统计分析</p>
      <p class="text-offset-2">使用场景：App启动时刻初始化SDK收集</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">设备信息，包括操作系统版本、设备机型、Android ID、设备序列号。</p>
      <p class="text-offset-2">网络信息，包括网络连接状态、接入网络的方式和类型。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://www.umeng.com/page/policy"
      >https://www.umeng.com/page/policy</a>
    </div>

    <div class="top-space">
      <p class="text-offset-2 title">{{ isIOS ? '5': '9' }}、视频连线</p>
      <p class="text-offset-2">所属机构：深圳市即构科技有限公司</p>
      <p class="text-offset-2">使用目的：用户视频连线后台人员，辅助完成现场作业。</p>
      <p class="text-offset-2">使用场景：app发起共享理赔需要视频连线</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">涉及个人信息：设备标识符(IMEI、IDFA、IDFV、Android ID、MACOAID、IMSI相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)、网络信息(IP 地址，WiFi 信息）、麦克风捕获的音频。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://www.zego.im/privacy"
      >https://www.zego.im/privacy</a>
    </div>

    <div class="top-space">
      <p class="text-offset-2 title">{{ isIOS ? '6': '10' }}、视频文件上传</p>
      <p class="text-offset-2">所属机构：深圳市即构科技有限公司</p>
      <p class="text-offset-2">使用目的：上传用户视频连线的文件，后台人员通过回放视频辅助完成作业、质检作业过程。</p>
      <p class="text-offset-2">使用场景：app发起共享理赔需要视频连线</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息类型：</p>
      <p class="text-offset-2">涉及个人信息：设备标识符(IMEI、IDFA、IDFV、Android ID、MACOAID、IMSI相关信息)、设备参数及系统信息(设备类型、设备型号、操作系统及硬件相关信息)、网络信息(IP 地址，WiFi 信息）、麦克风捕获的音频。</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://www.zego.im/privacy"
      >https://www.zego.im/privacy</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">11、Chromium SDK</p>
      <p class="text-offset-2">所属机构：谷歌科技有限公司</p>
      <p class="text-offset-2">使用目的：加载用户协议和隐私政策以及web页面</p>
      <p class="text-offset-2">使用场景：用户点击查看用户协议和隐私政策会跳转然后详细内容</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">会收集SSID、Wi-Fi网络信息、设备标识符、<span class="importance">访问的网址、浏览历史记录</span>、地理位置信息、剪切板</p>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">12、Okhttp</p>
      <p class="text-offset-2">所属机构：https://square.github.io</p>
      <p class="text-offset-2">使用目的：网络请求开源框架</p>
      <p class="text-offset-2">使用场景：发起网络请求</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">会收集SSID、Wi-Fi网络信息、设备标识符、<span class="importance">访问的网址、浏览历史记录</span></p>
    </div>

    <div
      class="top-space"
    >
      <p class="text-offset-2 title">{{ isIOS ? '7': '13' }}、兔小巢SDK</p>
      <p class="text-offset-2">所属机构：深圳市腾讯计算机系统有限公司</p>
      <p class="text-offset-2">使用目的：为用户提供意见反馈服务</p>
      <p class="text-offset-2">使用场景：留言板</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">最终用户的硬件型号、硬件序列号操作系统版本、设备配置、唯一设备标识符、国际移动设备身份码IMEI、SIM卡信息IMSI、iOS系统广告标识符（IDFA)、安卓系统广告标识符（OAID）、Android Id、设备Mac地址）、设备位置信息（通过<span class="importance">GPS</span>、蓝牙或Wi-Fi信号获得的位置信息）以及设备状态信息（设备应用安装列表）、应用信息（应用崩溃信息、通知开关状态、软件安装列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://privacy.qq.com/policy/tencent-privacypolicy"
      >https://privacy.qq.com/policy/tencent-privacypolicy</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">14、腾讯x5Web</p>
      <p class="text-offset-2">所属机构：深圳腾讯科技有限公司</p>
      <p class="text-offset-2">使用目的：加载用户作业页面</p>
      <p class="text-offset-2">使用场景：用户点击订单进入详情</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">会收集SSID、Wi-Fi网络信息、设备标识符、访问的网址、浏览历史记录</p>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">15、腾讯MMKV SDK</p>
      <p class="text-offset-2">所属机构：深圳腾讯科技有限公司</p>
      <p class="text-offset-2">使用目的：保存用户缓存数据</p>
      <p class="text-offset-2">使用场景：用户操作订单产生的缓存保存下来</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">无</p>
      <a
        class="text-offset-1"
        href="https://github.com/Tencent/MMKV"
      >https://github.com/Tencent/MMKV</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">16、glide</p>
      <p class="text-offset-2">所属机构：glide</p>
      <p class="text-offset-2">使用目的：图片处理</p>
      <p class="text-offset-2">使用场景：图片显示</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：收集软件安装列表</p>
      <p class="text-offset-2">读取联系人，修改<span class="importance">通讯录</span>，读取外置存储卡，写入外部存储卡</p>
      <a
        class="text-offset-1"
        href="https://github.com/bumptech/glide"
      >https://github.com/bumptech/glide</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">17、com.gyf.cacuts</p>
      <p class="text-offset-2">所属机构：cacuts</p>
      <p class="text-offset-2">使用目的：延长app存活时间方便用户接单</p>
      <p class="text-offset-2">使用场景：用户接单</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://github.com/gyf-dev/Cactus"
      >https://github.com/gyf-dev/Cactus</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">18、com.king.zxing</p>
      <p class="text-offset-2">所属机构：zxing</p>
      <p class="text-offset-2">使用目的：扫一扫识别二维码</p>
      <p class="text-offset-2">使用场景：用户扫一扫接单</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：相机、传感器</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://github.com/gyf-dev/Cactus"
      >https://github.com/zxing/zxing</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">19、com.alibaba.sdk.android.oss_android_sdk</p>
      <p class="text-offset-2">所属机构：阿里云oss存储sdk</p>
      <p class="text-offset-2">使用目的：存储用户上传的图片和视频</p>
      <p class="text-offset-2">使用场景：用户图片上传和视频上传</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：相机、传感器</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://github.com/gyf-dev/Cactus"
      >https://help.aliyun.com/document_detail/2249051.html</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">20、com.alibaba.idst.nui</p>
      <p class="text-offset-2">所属机构：阿里云设备端语音交互NUI SDK</p>
      <p class="text-offset-2">使用目的：存储用户上传的图片</p>
      <p class="text-offset-2">使用场景：用户图片上传</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：相机、传感器</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://github.com/gyf-dev/Cactus"
      >https://help.aliyun.com/document_detail/2249051.html</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">21、JZVideo</p>
      <p class="text-offset-2">所属机构：JZVideo</p>
      <p class="text-offset-2">使用目的：视频播放</p>
      <p class="text-offset-2">使用场景：视频上传后视频回放</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：无</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://github.com/gyf-dev/Cactus"
      >https://github.com/Jzvd/JZVideo</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">22、Pictureselector</p>
      <p class="text-offset-2">所属机构：pictureselector</p>
      <p class="text-offset-2">使用目的：获取媒体信息</p>
      <p class="text-offset-2">使用场景：用户选择相册上传</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：媒体库</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://github.com/gyf-dev/Cactus"
      >https://github.com/LuckSiege/PictureSelector</a>
    </div>

    <div
      class="top-space"
      v-if="!isIOS"
    >
      <p class="text-offset-2 title">{{ isIOS ? '8': '23' }}、微信Open SDK</p>
      <p class="text-offset-2">所属机构：微信开放平台</p>
      <p class="text-offset-2">使用目的：用户跳转小程序</p>
      <p class="text-offset-2">使用场景：我的账户 跳转小程序</p>
      <p class="text-offset-2">采集方式：SDK本机采集，不涉及数据共享</p>
      <p class="text-offset-2">收集的个人信息范围：无</p>
      <p class="text-offset-2">隐私政策链接：</p>
      <a
        class="text-offset-1"
        href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy"
      >https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</a>
    </div>

  </div>
</template>
<script>
import MobileDetect from 'mobile-detect';

export default {
  name: 'ThirdSdk',
  data() {
    return {
      isIOS: false
    };
  },

  mounted() {
    const userAgent = window.navigator.userAgent;
    const md = new MobileDetect(userAgent);
    const os = md.os();
    console.log('os', os);
    if (os === 'iOS') {
      this.isIOS = true;
    } else {
      this.isIOS = false;
    }
  }
};
</script>
<style lang="scss" scoped>
$indent: 20px;
.text-offset-2 {
  text-indent: $indent;
}

.text-offset-1 {
  margin-left: $indent;
  color: #3399FF;
}

.sdk-wrap {
  background-color: #F2F3F5;
  font-size: 18px;
  padding: 12px;
  line-height: 24px;
  color: #383838;
  overflow-y: auto;
  height: 100vh;

  .gray {
    color:#595959;
  }

  .top-space{
     margin-top: 24px;
     margin-bottom: 32px;
  }

  .title {
    font-size: 18px;
    font-weight: 500;
  }
  .importance {
    font-weight: 700;
    color: #3399ff;
  }
}

</style>
